import React from 'react';
import PropTypes from 'prop-types';

import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBQuoteImage = ({
  image,
  quote,
  authorName = '',
  authorPosition = '',
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb bb-quote bb-quote-image ${
      styles['bb-quote-image']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className="container">
      <div className="section-image">
        <img src={image.url} alt={image.alt} title={image.alt} width={100} height={100} />
      </div>

      <div className="section-main">
        <div className="quote">
          <div className="small-tag">
            <q>{quote}</q>
          </div>
        </div>

        <div className="author">
          {authorName && (
            <span className="name">
              <mark>
                {authorName}
                {authorPosition ? ' - ' : ''}
              </mark>
            </span>
          )}
          {authorPosition && (
            <span className="position">
              <mark>{authorPosition}</mark>
            </span>
          )}
        </div>
      </div>
    </div>
  </div>
);

BBQuoteImage.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }).isRequired,
  quote: PropTypes.string.isRequired,
  authorName: PropTypes.string,
  authorPosition: PropTypes.string,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBQuoteImage;
